import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { useEffect, useState } from "react";

import { getRequest } from "../../../api/apiCaller";
import Dialog from "../../../components/Dialog";
import DataNotFound from "./DataNotFound";
import classes from "./TableReportChargeTelecom.module.css";

const DUMMY_DATA = [
  {
    from: "0906086801",
  },
];
const TableReportChargeTelecom = ({ reportChargeTelecomFilter, callType }) => {
  const COLUMNS_1 = [
    // TODO change name
    {
      id: "from",
      name: "Đầu số MST",
      width: 200,
    },
    {
      name: "Mạng bị gọi",
      customValue: () => "MobiFone",
    },
    {
      name: "Loại cuộc gọi",
      customValue: () => "Nội mạng",
    },
    {
      name: "Sản lượng(phút)",
      customValue: (row) => "10,219",
    },
    {
      name: "Đơn giá sau VAT (VNĐ/phút)",
      customValue: (row) => 450,
    },
    {
      name: "Cước dịch vụ",
      customValue: (row) => "8,175,200",
    },
  ];

  const COLUMNS_2 = [
    {
      name: "Nội dung",
      customValue: () => "0906086801",
    },
    {
      name: "Phí hòa mạng",
      customValue: () => "MobiFone",
    },
    {
      name: "Phí duy trì thuê bao",
      customValue: () => "55,000",
    },
    {
      name: "Tổng",
      customValue: (row) => "55,000",
    },
  ];

  const [reportChargeTelecomData, setReportChargeTelecomData] =
    useState(DUMMY_DATA);
  const [where, setWhere] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getReportChargeTelecom = () => {
    setIsLoading(true);

    getRequest("/cloud-pbx/testing", {
      filter: {
        order: "startedAt DESC",
        where,
      },
    })
      .then((res) => {
        setReportChargeTelecomData(res.data);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  const renderTableCellValue = (row, column) => {
    let value = column.customValue
      ? column.customValue(row, column)
      : row[column.id];
    return value;
  };

  useEffect(() => {
    const whereFilter = reportChargeTelecomFilter?.where;
    if (whereFilter) setWhere(whereFilter);
  }, [reportChargeTelecomFilter]);

  useEffect(() => {
    if (where !== null) {
      getReportChargeTelecom();
    }
  }, [where]);

  return (
    <>
      {reportChargeTelecomData && (
        <Paper style={{ color: "black", padding: 16 }}>
          {reportChargeTelecomData.length > 0 && (
            <>
              <div className={classes.tableContainer}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        style={{ width: 60 }}
                        className={classes.tableBodyCell}>
                        STT
                      </TableCell>
                      {COLUMNS_1.map((column, key) => (
                        <TableCell
                          key={key}
                          align={column.align}
                          style={{ width: column.width }}
                          className={classes.tableBodyCell}>
                          {column.name}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reportChargeTelecomData.map((row, columnIndex) => (
                      <TableRow key={columnIndex}>
                        <TableCell
                          align="center"
                          className={classes.tableBodyCell}>
                          {columnIndex + 1}
                        </TableCell>
                        {COLUMNS_1.map((column, cellIndex) => (
                          <TableCell
                            key={cellIndex}
                            align={column.align}
                            className={classes.tableBodyCell}
                            style={{ width: column.width }}>
                            {renderTableCellValue(row, column)}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell
                        colSpan={COLUMNS_1.length}
                        className={classes.tableBodyCell}
                        align="center">
                        Tổng Cước Lưu Lượng (Đã bao gồm thuế)
                      </TableCell>
                      <TableCell className={classes.tableBodyCell}>
                        {"31,859,000"}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>

              <Typography variant="h6" style={{ margin: "25px 0px 10px 0px" }}>
                Bảng kê phí thuê bao dịch vụ cước viễn thông
              </Typography>
              <div className={classes.tableContainer}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        style={{ width: 60 }}
                        className={classes.tableBodyCell}>
                        STT
                      </TableCell>
                      {COLUMNS_2.map((column, key) => (
                        <TableCell
                          key={key}
                          align={column.align}
                          style={{ width: column.width }}
                          className={classes.tableBodyCell}>
                          {column.name}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reportChargeTelecomData.map((row, columnIndex) => (
                      <TableRow key={columnIndex}>
                        <TableCell
                          align="center"
                          className={classes.tableBodyCell}>
                          {columnIndex + 1}
                        </TableCell>
                        {COLUMNS_2.map((column, cellIndex) => (
                          <TableCell
                            key={cellIndex}
                            align={column.align}
                            className={classes.tableBodyCell}
                            style={{ width: column.width }}>
                            {renderTableCellValue(row, column)}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        className={classes.tableBodyCell}
                        align="center">
                        Tổng Cước Lưu Lượng (Đã bao gồm thuế)
                      </TableCell>
                      <TableCell className={classes.tableBodyCell}>
                        {"31,859,000"}
                      </TableCell>
                      <TableCell className={classes.tableBodyCell}>
                        {"31,859,000"}
                      </TableCell>
                      <TableCell className={classes.tableBodyCell}>
                        {"31,859,000"}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
            </>
          )}

          {reportChargeTelecomData.length === 0 && <DataNotFound />}
        </Paper>
      )}
      {<Dialog open={isLoading} title={<CircularProgress />} />}
    </>
  );
};

export default TableReportChargeTelecom;
